import React, { useEffect, useState } from "react";
import { Button, PlusIcon, TrashIcon } from "evergreen-ui";
import { Table, Card } from "antd";
import FireFetch from "../../../Firebase/FireFetch";
import { TableExport } from "tableexport";
import { useListVals } from "../../../Firebase/databaseHooks";
import Firebase from "../../../Firebase/Firebase";
import { getDatabase, ref } from "firebase/database";

var db = getDatabase(Firebase);

const ZoneLayout = (props) => {
	const canCreate = props.canCreate !== false;
	const canDelete = props.canDelete !== false;
	const columns = [
		{
			title: 'Zone',
			dataIndex: 'zone',
			key: 'zone',
			sorter: (a, b) => a.zone && a.zone.localeCompare(b.zone),
		},
		{
			title: 'Code',
			dataIndex: 'code',
			key: 'code',
			sorter: (a, b) => a.code && a.code.localeCompare(b.code),
		},
		{
			title: 'Action',
			dataIndex: 'action',
			key: 'action',
		}
	]
	const [zoneArray, setZoneArray] = useState([]);
	const [arrayIn, loading] = useListVals(ref(db, "talmidsdb/zones"));
	const [countryArray] = useListVals(ref(db, "talmidsdb/countries"));

	useEffect(() => {
		if (arrayIn) {
			var tempArray = [];
			arrayIn.map((item, index) => {
				tempArray.push({
					key: index,
					zone: item.zone,
					code: item.id,
					action: canDelete ? (
						<Button intent="danger" onClick={() => {
							props.messageBack("zones", "delete", item.id);

						}}>
							<TrashIcon color="danger" />
						</Button>
					) : null
				})
			});

			setZoneArray(tempArray);

		}

	}, [arrayIn, countryArray, props, canDelete]);


	return (
		<div className="font-Nunito">
			<div>
				{canCreate && (
					<Button appearance="primary" className="ml-3 my-2" onClick={() => {
						props.messageBack("zones", "create");
					}}>
						New Zone <PlusIcon />
					</Button>
				)}
				<Button appearance="primary" className="mx-2" onClick={() => {
					FireFetch.exportXL(TableExport(document.getElementById("dataTable"), {
						filename: "Zones",
						exportButtons: false,
						sheetname: "Zones",
					}), zoneArray);
				}}>
					Print
				</Button>
			</div>
			<Card className="d-flex flex-column">
				<div>
					<Table style={{ overflow: "auto" }} loading={loading}
						pagination={{ defaultPageSize: 100, showSizeChanger: true, pageSizeOptions: ['20', '50', '100'] }}
						id={"dataTable"} dataSource={zoneArray} columns={columns} />
				</div>
			</Card>
		</div>

	);
}

export default ZoneLayout;
